import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createTheme } from "@mui/material/styles";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider, withCookies } from "react-cookie";
import { persistor, store } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { getCookie, setCookie } from "./app/utils/cookies";

var theme: any;
var styles: any;
var startupData: any;

const muiBaseTheme = createTheme();
var siteSettings = undefined;

function evaluateJson(jsonObj: any) {
  Object.keys(jsonObj).forEach((attr) => {
    if (typeof jsonObj[attr] === "object") {
      evaluateJson(jsonObj[attr]);
    } else {
      jsonObj[attr] =
        isNaN(jsonObj[attr]) && jsonObj[attr].search("`") >= 0
          ? eval(jsonObj[attr])
          : jsonObj[attr];
    }
  });
  return;
}

export function fetchStartupFiles() {
  return new Promise<void>((resolve, reject) => {
    try {
      // if (
      //   sessionStorage.getItem("sessionRetryCount") &&
      //   Number(sessionStorage.getItem("sessionRetryCount")) >= 3
      // )
      //   sessionStorage.setItem("sessionRetryCount", "0");

      /* Fetch mdtheme.json and apply */
      fetch("./mdtheme.json")
        .then((response) => response.json())
        .then(async (themeData) => {
          siteSettings = themeData.siteSettings;

          /* Parse theme and evaluate the escaped variables */
          evaluateJson(themeData.customisation.components);

          /* Apply muiBaseTheme toolbar attributes */
          if (themeData.customisation.components.MuiToolbar)
            themeData.customisation.components.MuiToolbar.styleOverrides.root = {
              ...themeData.customisation.components.MuiToolbar.styleOverrides
                .root,
              ...muiBaseTheme.mixins.toolbar,
            };

          theme = createTheme(themeData.customisation);

          /* Fetch mdcomponents.json and apply */
          fetch("./mdcomponents.json")
            .then((response) => response.json())
            .then(async (componentsData) => {
              /* Parse components styling and evaluate the escaped variables */
              evaluateJson(componentsData);

              styles = componentsData;

              /* Apply muiBaseTheme toolbar attributes */
              styles.toolbar = {
                ...styles.toolbar,
                ...muiBaseTheme.mixins.toolbar,
              };

              styles.content.transition = `${theme.transitions.create(
                "margin",
                styles.content.transition
              )}ms`;

              styles.contentShift.transition = `${theme.transitions.create(
                "margin",
                styles.contentShift.transition
              )}ms`;

              /* fetch the startup file */
              fetch("./startup.json")
                .then((response) => response.json())
                .then(async (data) => {
                  startupData = data;

                  /* Fetch the build file */
                  fetch("./build.json")
                    .then((response) => response.json())
                    .then(async (data) => {
                      var serializedState = sessionStorage.getItem(
                        "persist:rootSession"
                      );

                      if (
                        serializedState != undefined &&
                        JSON.parse(serializedState).appBar &&
                        JSON.parse(JSON.parse(serializedState).appBar)
                          .buildData &&
                        JSON.parse(JSON.parse(serializedState).appBar).buildData
                          .Build != data.Build
                      ) {
                        //Delete cookie
                        if (
                          getCookie(
                            `Session_${startupData.sessionPayload.application}_${startupData.sessionPayload.environment}`
                          )
                        ) {
                          console.log("Build changed !");
                          setCookie(
                            `Session_${startupData.sessionPayload.application}_${startupData.sessionPayload.environment}`,
                            "",
                            0
                          );
                        }

                        // Remove storage
                        sessionStorage.removeItem("persist:rootSession");
                        localStorage.removeItem("persist:rootLocal");

                        // // Delete caches
                        // caches
                        //   .keys()
                        //   .then((keyList) =>
                        //     Promise.all(
                        //       keyList.map((key) => caches.delete(key))
                        //     )
                        //   );

                        resolve();
                      } else {
                        resolve();
                      }
                    })
                    .catch((e) => {
                      console.log("Build data fetch fail: ", e);
                      return;
                    });
                })
                .catch((e) => {
                  console.log("Startup fetch fail: ", e);
                  return;
                });
            })
            .catch((e) => {
              console.log("Components style fetch fail: ", e);
              return;
            });
        })
        .catch((e) => {
          console.log("Theme fetch fail: ", e);
          return;
        });
    } catch (e) {
      console.log(e);
      return;
    }
  });
}

const Index = () => {
  return (
    // <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          {theme && styles ? (
            <App theme={theme} styles={styles} startupData={startupData} />
          ) : (
            ""
          )}
        </PersistGate>
      </Provider>
    </CookiesProvider>
    // </React.StrictMode>
  );
};

async function main() {
  await fetchStartupFiles();
  const root = ReactDOM.createRoot(
    document.getElementById("page") as HTMLElement
  );
  root.render(<Index />);
}

main().catch((e) => {
  console.log(e);
  return;
});

export default withCookies(Index);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
